<template>
  <div>
    <telephony-operators-report-header @generate="generate" @filterChanged="filterChanged"
    @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd"
    :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"/>

    <basic-table
      v-if="reportPayment"
      :items="reportPayment"
      :fields="reportPaymentFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"/>
    <table-manager-bottom
    :totalRows="totalRows" :perPage="perPage"
    v-model="currentPage"/>
  </div>
</template>

<script>

export default {
  props: {
    editItem: null
  },
  data () {
    return {
      reportPayment: [],
      reportPaymentFields: [
        {key: 'sum', label: this.$i18n.t('Payment summ'), sortable: true},
        {key: 'currencyName', label: this.$i18n.t('Currency type'), sortable: true},
        {key: 'payment_date', label: this.$i18n.t('Payment date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'reason_of_payment', label: this.$i18n.t('Payment comment'), sortable: true}
      ],
      isGenerateDisabled: false,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      currentTab: 1,
      filterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      }
    }
  },
  methods: {
    async generate () {
      this.isGenerateDisabled = true
      let generate = {
        numDateEnd: 0,
        numDateStart: 0,
        supplier_id: 0
      }
      generate.numDateEnd = Number(this.dateEnd) / 1000
      if (generate.numDateEnd > 2147483647) generate.numDateEnd = 2147483647
      generate.numDateStart = Number(this.dateStart) / 1000
      if (generate.numDateStart > 2147483647) generate.numDateStart = 2147483647
      generate.supplier_id = this.editItem.id
      let reportPayment = await this.$store.dispatch('Settings/GET_REPORT_PAYMENTS', generate)
      this.reportPayment = reportPayment.data
      for (let el of this.reportPayment) {
        for (let elCurrencies of this.currencies) {
          if (el.currency_type === elCurrencies.currency_id) {
            el.currencyName = elCurrencies.currency_brief_name
            break
          }
        }
      }
      this.loadDone()
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    currencies () {
      return this.$store.getters['ReferenceBooks/CURRENCIES']
    }
  },
  mounted () {
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/telephony/telephoneOperators/reportPayment.vue